
<span>
  <border-style-options
    :mode="mode"
    :border-style="selected.borderStyle || 'none'"
    :border-color="selected.borderColor || null"
    :border-width="selected.borderWidth || 0"
    :show-border-radius="false"
    :update-prop-function="
      (key, value) => updateProp({ key: key, value: value })
    "
  />
</span>
